import axios from "axios";
import {db} from "@src/services/db";
import {useAuthStore} from "@src/stores/auth";
import {useChatSessionStore} from "@src/stores/chatSession";
import type ChatMessage from "@src/types/ChatMessage";
import type ChatSession from "@src/types/ChatSession";
import NotificationsService from "@src/services/notifications";

type NewMessageEventPayload = {
    message: ChatMessage;
    tempId?: string | number | null;
};

async function ensureSessionExists(sessionId: number, from: string): Promise<ChatSession | null> {
    const local = await db.sessions.get(sessionId);
    if (local) {
        updateExpiration(sessionId, from, local.channel.type)
        return local as any;
    }

    try {
        const {data} = await axios.get(`/operator/v4/fetch-session/${sessionId}`, {
            withCredentials: true,
        });

        const session = (data?.data ?? data) as ChatSession;
        if (!session?.id) return null;

        await db.sessions.put({
            ...session,
            updated_at: Date.now(),
        } as any);

        updateExpiration(sessionId, from, session.channel.type)

        return session;
    } catch (e) {
        console.error("❌ Não foi possível buscar a sessão:", sessionId, e);
        return null;
    }
}

async function upsertMessage(payload: NewMessageEventPayload, notifyNewMessage: boolean = false) {
    const msg = payload.message;
    const sessionId =
        (msg as any).chat_session_id ??
        (msg as any).session_id ??
        (msg as any).session?.id;

    if (!sessionId) return;

    await ensureSessionExists(Number(sessionId), payload.message.from);

    if (payload.tempId) {
        await db.messages.delete(payload.tempId as any).catch(() => {
        });
    }

    const exists = await db.messages.get(msg.id as any);
    if (exists) return;

    await db.messages.put({
        ...msg,
        chat_session_id: Number(sessionId),
        updated_at: Date.now(),
    } as any);

    await db.sessions.update(Number(sessionId), {
        last_message: msg,
        has_new_messages: notifyNewMessage,
        updated_at: Date.now(),
    } as any);

}

function updateExpiration(sessionId: number, from: string, channelType: string) {
    const sessionStore = useChatSessionStore();
    if (channelType === 'whatsapp' || from !== 'costumer') {
        return
    }
    db.sessions.update(sessionId, {
        is_expired: false,
        updated_at: Date.now().toString()
    })
    if (sessionStore.selectedSession?.id === sessionId) {
        sessionStore.selectedSession.is_expired = false;
    }
}

export function NewMessageListener() {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();

    const userId = auth.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets.private(`user.${userId}`)
        .listen(".NewChatMessageEvent", async (event: NewMessageEventPayload) => {
            try {
                const msg = event.message;
                const sid =
                    (msg as any).chat_session_id ??
                    (msg as any).session_id ??
                    (msg as any).session?.id;
                const isSelected = sessionStore.selectedSession?.id === Number(sid);

                await upsertMessage(event, !isSelected);

                if (isSelected) {
                    const session = sessionStore.selectedSession;
                    if (session && session.messages.length === 0) {
                        await sessionStore.selectSession(session);
                    }
                    sessionStore.scrollDown?.();
                } else if (event.message.sender.type === 'costumer') {
                    NotificationsService.notify(event.message.sender.name + ' enviou uma mensagem');
                }
            } catch (e) {
                console.error("❌ erro no listener NewChatMessageEvent", e);
            }
        });
}